import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { string, number, func, bool } from 'prop-types';
import { DATA_TAGGER_TYPE, dataTaggerActionAdd, dataTaggerActionModify, dataTaggerActionRemove } from '@laramie/ui';
import '@laramie/ui/dist/components/controls/DataTaggerModalRedux/index.css';
import { DataTagger, Modal } from '../../common';



const DataTaggerModalRedux = (props) => {

  //hooks
  const [state, setState] = useState({
    processKey: "",
    entidad: "",
    idEntidad: 0
  });

  const [controllerDataTagger, setControllerDataTagger] = useState({
    entidad: "",
    idEntidad: 0,
    data: {
      archivos: [],
      observaciones: [],
      etiquetas: []
    },
    addRow: (dataTaggerType, row, success, error) => {},
    removeRow: (dataTaggerType, row, success, error) => {}
  });

  const dispatch = useDispatch();
  const dataTagger = useSelector( (state) => state.dataTagger.data );

  const mount = () => {
    setState(prevState => {
      return {...prevState,
        processKey: props.processKey,
        entidad: props.entidad,
        idEntidad: props.idEntidad
      };
    });
  }
  useEffect(mount, [props]);

  useEffect(() => {
      setControllerDataTagger({
          entidad: state.entidad,
          idEntidad: state.idEntidad,
          data: (dataTagger && dataTagger[state.processKey]) ? {
              archivos: dataTagger[state.processKey].Archivo.filter(f => f.entidad === state.entidad && f.idEntidad === state.idEntidad && f.state !== 'r'),
              observaciones: dataTagger[state.processKey].Observacion.filter(f => f.entidad === state.entidad && f.idEntidad === state.idEntidad && f.state !== 'r'),
              etiquetas: dataTagger[state.processKey].Etiqueta.filter(f => f.entidad === state.entidad && f.idEntidad === state.idEntidad && f.state !== 'r')
          } : {
              archivos: [],
              observaciones: [],
              etiquetas: []
          },
          addRow: (dataTaggerType, row, success, error) => {
              let list = null;
              switch(dataTaggerType) {
                  case DATA_TAGGER_TYPE.ARCHIVO:
                      list = dataTagger[state.processKey].Archivo;
                      break;
                  case DATA_TAGGER_TYPE.OBSERVACION:
                      list = dataTagger[state.processKey].Observacion;
                      break;
                  case DATA_TAGGER_TYPE.ETIQUETA:
                      list = dataTagger[state.processKey].Etiqueta;
                      break;
                  default:
                      break;
              }
              let idMin = Math.min(...list.map(x => x.id));
              row.id = (idMin >= 0) ? -1 : --idMin; //las altas tienen un id negativo
              row.state = 'a';

              dispatch(dataTaggerActionAdd(state.processKey,dataTaggerType,row));
              success();
          },
          removeRow: (dataTaggerType, row, success, error) => {
              if (row.id <= 0) {
                  dispatch(dataTaggerActionRemove(state.processKey,dataTaggerType,row));
              }
              else {
                  row.state = 'r';
                  dispatch(dataTaggerActionModify(state.processKey,dataTaggerType,row));
              }
              success();
          }
      });  
  }, [dataTagger, state.entidad, state.idEntidad, state.processKey]);


  const registro = props.registro || '';
  const sujeto = registro.startsWith('el ') ? `del ${registro.slice(3)}` : `de ${registro}`;
  const modalTitle = registro ? `Información adicional ${sujeto}` : props.title;

  return (
    <div className='data-tagger-modal'>

      <Modal
        size="lg"
        title={modalTitle}
        tipName={props.tipName}
        onEscape={() => props.onDismiss()}
        body={(
              <DataTagger
                controller={controllerDataTagger}
                disabled={props.disabled}
                ocultarArchivos={props.ocultarArchivos}
              />
        )}
        footer={(
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
        )}
        footerClassName="f-align"
      />

    </div>
  );
}

DataTaggerModalRedux.propTypes = {
  disabled: bool,
  ocultarArchivos: bool,
  title: string.isRequired,
  registro: string,
  processKey: string.isRequired,
  entidad: string.isRequired,
  idEntidad: number.isRequired,
  onDismiss: func.isRequired,
  tipName: string
};

DataTaggerModalRedux.defaultProps = {
  disabled: false,
  registro: '',
  tipName: ''
};

export default DataTaggerModalRedux;
